import * as Sentry from '@sentry/browser';

import { SENTRY_TAG_SYSTEM_DOMAIN_ID } from '../../utils/constants/sentry';

export function destroySentryUserContext(): void {
  const scope = Sentry.getCurrentScope();
  scope.setUser(null);
  scope.setTag(SENTRY_TAG_SYSTEM_DOMAIN_ID, undefined);
}
